import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta12ExemplosEnum,
  ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum,
  ConsultaSeguimentoPergunta12Model,
} from './model-consultaSeguimentoPergunta12'

const pergunta12ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta12ExemplosEnum)

const pergunta12ExemplosPassouFalhouEnumValues = Object.values(ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum)

export function hasPergunta12ExemplosAtLeastTwoSim(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS']
): boolean {
  return Object.values(value ?? {}).filter((item) => item === SimNaoEnum.SIM).length >= 2
}

export function isPergunta12ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS']
): boolean {
  return isAllFilled(
    (value ?? {}) as Record<ConsultaSeguimentoPergunta12ExemplosEnum, SimNaoEnum>,
    pergunta12ExemplosEnumValues
  )
}

export function isPergunta12ExemplosPassouFalhouAllFilled(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta12ExemplosPassouFalhouEnumValues)
}

export function isPergunta12ExemplosAllNao(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta12ExemplosPassouFalhouEnumValues)
}

export function hasPergunta12ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta12ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}
